var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('Channels',{attrs:{"loading":_vm.pending,"channels":_vm.channels},on:{"channel-deleted":_vm.removeChannelId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }